/**
 * Transform a single value from timestamp string/number to Date object
 */
export const transformDateTimeValue = (value: unknown): Date | null | undefined => {
  // Skip null/undefined values
  if (value === null || value === undefined) return value;

  // Handle string timestamps
  if (typeof value === 'string') {
    // Try parsing as timestamp number
    const timestamp = +value;
    if (!isNaN(timestamp) && timestamp > 0) {
      return new Date(timestamp);
    }

    // Try parsing as ISO date string
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  // Handle numeric timestamps
  if (typeof value === 'number' && value > 0) {
    return new Date(value);
  }

  // Return original value if no transformation needed
  return value as Date;
};

export const utcToLocalString = (isoString: string): string => {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return isoString; // Return original string if invalid date
  }
  return date.toLocaleString();
};
